export function getLocaleValue(key: string, fallback = ''): string {
  return window.localeData?.[key] ?? fallback;
}

export function getValidationLocaleValue(key: string, fallback = ''): string {
  return window.validationLocaleData?.[key] ?? fallback;
}

export function getCurrentLanguage() {
  return document.documentElement.getAttribute('lang') ?? 'ru';
}
